import { useIsomorphicLayoutEffect } from './helpers';
import { useSubscriptionInternal } from './internal/use-subscription-internal';
export function useLayoutSubscription(input$, observerOrNext$, error, complete) {
    return useSubscriptionInternal(useIsomorphicLayoutEffect, [
        input$,
        observerOrNext$,
        error,
        complete
    ]);
}
//# sourceMappingURL=use-layout-subscription.js.map